import React, { useState, useCallback } from 'react';
import Toast from '../components/Toast';

interface ToastState {
  id: number;
  message: string;
  type: 'success' | 'error';
}

export function useToast() {
  const [toast, setToast] = useState<ToastState | null>(null);

  const showToast = useCallback((message: string, type: 'success' | 'error' = 'success') => {
    setToast({ 
      id: Date.now(),
      message, 
      type 
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast(null);
  }, []);

  const ToastComponent = toast ? (
    <Toast 
      key={toast.id}
      message={toast.message} 
      type={toast.type} 
      onClose={hideToast} 
    />
  ) : null;

  return { showToast, ToastComponent };
}
